import { API } from '../index';

import { constants } from '../../Configs/constants';

const {
  endpoints: {
    ADD_CAREER,
    DELETE_CAREER,
    GET_CAREER,
    UPDATE_CAREER,
    ADVERT_CAREER,
  },
} = constants;

export const createCareer = async (config, { body }) =>
  await API.post(ADD_CAREER, body, config);

export const getCareer = async () => await API(GET_CAREER);

export const updateCareer = async (config, { body, id }) =>
  await API.patch(UPDATE_CAREER + '/' + id, body, config);

export const delCareer = async (config, id) =>
  await API.delete(DELETE_CAREER + '/' + id, config);

export const advertCareer = async ({ body, id }) =>
  await API.post(ADVERT_CAREER + '/' + id, body);
